import React, { useEffect } from 'react';
import {
  Route,
  Routes,
  Link,
  Outlet
} from 'react-router-dom';

import Blog from './components/Pages/Blog';
import BlogPost from './components/Pages/BlogPost';
import PageNotFound from './components/Pages/PageNotFound';
import PrivacyPolicy from './components/Pages/PrivacyPolicy';
import TermsAndConditions from './components/Pages/TermsAndConditions';
import Footer from './components/Organisms/Footer';
import Header from './components/Organisms/Header';
import Home from './components/Pages/Home';
import Icon from './components/Atoms/Icon';
import Clients from './components/Pages/Clients';
import Candidate from './components/Pages/Candidate';
import About from './components/Pages/About';
import OurCandidates from './components/Pages/OurCandidates';
import WorkAt from './components/Pages/WorkAt';
import Expertise from './components/Pages/Expertise';
import Contact from './components/Pages/Contact';
import Careers from './components/Pages/Careers';
import JobDetail from './components/Pages/JobDetail';
import SuccessPage from './components/Pages/SuccessPage';
import Scan from './components/Pages/Scan';
import Forms from './components/Pages/Forms';

const routes = [
  {
    name: 'Blog',
    path: '/blog',
    element: (
      <>
        <Header />
        <Blog />
      </>
    )
  },
  {
    name: 'Post',
    path: '/post',
    element: (
      <>
        <Header />
        <BlogPost />
      </>
    )
  },
  {
    name: '404',
    path: '/404',
    element: (
      <>
        <Header />
        <PageNotFound />
      </>
    )
  },
  {
    name: 'Privacy policy',
    path: '/privacy-statement',
    element: (
      <>
        <Header />
        <PrivacyPolicy />
      </>
    )
  },
  {
    name: 'Terms and conditions',
    path: '/algemene-voorwaardent',
    element: (
      <>
        <Header />
        <TermsAndConditions />
      </>
    )
  },
  {
    path: '*',
    element: (
      <>
        <Header />
        <PageNotFound />
      </>
    )
  },
  {
    name: 'Home',
    path: '/',
    element: (
      <>
        <Header absolute theme="light" />
        <Home />
      </>
    )
  },
  {
    name: 'About',
    path: '/about',
    element: (
      <>
        <Header absolute theme="light" />
        <About />
      </>
    )
  },
  {
    name: 'Work at',
    path: '/work-at',
    element: (
      <>
        <Header absolute theme="light" />
        <WorkAt />
      </>
    )
  },
  {
    name: 'Clients',
    path: '/clients',
    element: (
      <>
        <Header absolute />
        <Clients />
      </>
    )
  },
  {
    name: 'Our Candidates',
    path: '/our-candidates',
    element: (
      <>
        <Header absolute />
        <OurCandidates />
      </>
    )
  },
  {
    name: 'Candidate',
    path: '/candidate',
    element: (
      <>
        <Header absolute />
        <Candidate />
      </>
    )
  },
  {
    name: 'Expertise',
    path: '/expertise',
    element: (
      <>
        <Header absolute theme="light" />
        <Expertise />
      </>
    )
  },
  {
    name: 'Contact',
    path: '/contact',
    element: (
      <>
        <Header absolute theme="light" />
        <Contact />
      </>
    )
  },
  {
    name: 'Careers',
    path: '/careers',
    element: (
      <>
        <Header absolute theme="light" />
        <Careers />
      </>
    )
  },
  {
    name: 'Job Detail',
    path: '/job-detail',
    element: (
      <>
        <Header absolute theme="light" />
        <JobDetail />
      </>
    )
  },
  {
    name: 'Success Page',
    path: '/success',
    element: (
      <>
        <Header absolute />
        <SuccessPage />
      </>
    )
  },
  {
    name: 'Scan',
    path: '/scan',
    element: (
      <>
        <Header />
        <Scan />
      </>
    )
  },
  {
    name: 'Forms',
    path: '/forms',
    element: <Forms />
  }
  // Add new routes here
];

function RouterNav() {
  return (
    <div className="group fixed z-[52]">
      <div className="fixed bottom-0 left-0 flex h-10 w-10 cursor-pointer items-center justify-center border-2 border-sl-blue bg-white">
        <Icon icon="bars" />
      </div>
      <div className="fixed -bottom-full -left-full m-auto h-80 max-h-fit w-96 max-w-full overflow-auto border-2 border-sl-blue bg-white px-7 py-7 duration-300 group-hover:left-0 group-hover:bottom-0 md:px-7">
        <ul>
          {routes.map((route) => (
            <li key={routes.indexOf(route)}>
              <Link
                to={route.path}
                className="text-black hover:text-purple-500"
              >
                {route.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function Layout() {
  return (
    <div>
      <RouterNav /> <Outlet />
    </div>
  );
}

function App() {
  let windowWidth = window.innerWidth;
  let resizeTimer: NodeJS.Timeout;

  const resizeClass = () => {
    if (windowWidth !== window.innerWidth) {
      document.body.classList.add('resize-active');
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.body.classList.remove('resize-active');
      }, 400);
    }

    windowWidth = window.innerWidth;
  };

  useEffect(() => {
    window.addEventListener('resize', resizeClass);
    return () => {
      window.removeEventListener('resize', resizeClass);
    };
  }, []);
  return (
    <div className="flex min-h-[100vh] w-full flex-col justify-between overflow-clip break-words">
      <Routes>
        <Route path="/" element={<Layout />}>
          {routes.map((route) => (
            <Route {...route} key={routes.indexOf(route)} />
          ))}
        </Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
